import {Component, OnInit} from '@angular/core';
import {environment} from "../../environments/environment";
import {BreadcrumbService} from "xng-breadcrumb";
import {Globals} from "../globals";

@Component({
  standalone: false,
    selector: 'app-layout',
    templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent {
  url: any;
  imageSrc: any;
  environment: any;
    constructor() {}


    ngOnInit(): void {

    }
}
